export const strings = {
  followUs: {
    en: 'Follow us!',
    fr: 'Suivez nous !',
  },

  moreContacts: {
    en: 'More contacts',
    fr: 'Plus de contacts',
  },

  contact: {
    en: 'Contact',
    fr: 'Nous contacter',
  },

  subscribeToNewsletter: {
    en: 'Subscribe to our newsletter',
    fr: 'Rejoignez notre newsletter',
  },
};
